export default __webpack_public_path__ + "static/media/im01.3451e4e3.png";